import React, { Component } from "react";
import { ReactComponent as Logo } from "../assets/logo.svg";
import { Link } from "react-router-dom";
import { ReactComponent as CloseIcon } from "../assets/close.svg";
import { ReactComponent as HamburgerIcon } from "../assets/hamburger.svg";
import { ReactComponent as ChevronRightIcon } from "../assets/chevron-right.svg";
import { ReactComponent as UserIcon } from "../assets/user.svg"
import Context from "../models/Context";
import SocialShare from './SocialShare'
import LanguageSelector from './LanguageSelector'
import './SocialShare.scss'
import './LanguageSelector.scss'

class Navbar extends Component {
  constructor() {
    super();
    this.state = {
      isOnline : navigator.onLine,
      isNavbarOpen: false,
      isHamburgerMenuOpen: false // window.innerWidth < MOBILE_BREAKPOINT,
    };

    this.handleOnline = this.handleOnline.bind(this);
    this.handleOffline = this.handleOffline.bind(this);
  }

  handleOnline() {
    this.setState({ isOnline: true });
  }

  handleOffline() {
    this.setState({ isOnline: false });
  }


  componentDidMount() {
    window.IconicJS().inject(".aw-navbar img.iconic");
    window.addEventListener('online', this.handleOnline);
    window.addEventListener('offline', this.handleOffline);
  }

  componentWillUnmount() {
    window.removeEventListener('online', this.handleOnline);
    window.removeEventListener('offline', this.handleOffline);
  }

  toggleMenu = () => {
    this.setState({
      isHamburgerMenuOpen: !this.state.isHamburgerMenuOpen,
    });
  };
  render() {
    const { renderHeaderLeft, renderHeaderRight } = this.props;

    return (
      <Context.Consumer>
        {(context) => {
          const { t, state } = context;
          const { user } = state;
          const navbarPosition = this.state.isNavbarOpen
            ? "right-0"
            : "-right-80";

          return (
            <div className="fixed z-10 top-0 left-0 right-0">
            <div
              className={`flex flex flex-row w-80 ${navbarPosition} right-auto w-full h-auto py-4 px-0 md:px-4 md:space-x-4 space-x-1 bg-white z-20 justify-between items-center shadow-md border border-b-1 border-gray-lightest`}
            >
              <button className="absolute w-16 h-16 flex justify-center items-center top-0 -left-16 bg-petrol active:bg-petrol-darker rounded-bl-md focus:outline-none focus:bg-petrol-darker">
                {this.state.isNavbarOpen ? (
                  <CloseIcon
                    className="m-4 h-12 fill-current text-white"
                    onClick={this.toggleMenu}
                  />
                ) : (
                  <HamburgerIcon
                    className="m-4 h-12 fill-current text-white"
                    onClick={this.toggleMenu}
                  />
                )}
              </button>
              <Link to="/" className="hidden md:block">
                <Logo
                  onClick={this.navigateToHome}
                  className="w-14 h-14 fill-current text-gray "
                ></Logo>
              </Link>
              <h1 className="hidden md:block text-gray uppercase tracking-wide my-8 md:my-0 text-lg sm:text-xl">
                <Link to="/">wettermelden.at</Link>
              </h1>
              {this.state.isOnline ? <span className="h-6 rounded-md text-xs p-1 bg-petrol text-white">online</span> : <span className="h-6 rounded-md text-xs p-1 bg-red text-white">offline</span>}

              {(user.username) ? (
                <React.Fragment>
                <Link className="text-gray flex flex-row space-x-1.5 items-center" to="/my/">
                  <button className="btn-icon-small bg-petrol text-white active:bg-petrol-darker">
                    <UserIcon />
                  </button>
                  <div className="hidden md:block">
                    {'tommy' || user.username}
                  </div>
                </Link>

                </React.Fragment>
              ) : (
                <React.Fragment>
                <Link className="text-gray flex flex-row space-x-1.5 items-center" to="/login/">
                  <button className="btn-icon-small bg-petrol text-white active:bg-petrol-darker">
                    <UserIcon />
                  </button>
                  <div className="hidden md:block">{t("SCREENS.LOGIN.TITLE")}</div>
                </Link>

                </React.Fragment>
              )}

              <div className="flex-1 flex-col flex-col-reverse relative top-0 md:top-11 z-30">
                <div className="flex flex-1 text-center hidden">
                  {renderHeaderLeft && renderHeaderLeft()}
                </div>
                <div className="flex relative flex-row justify-end">
                  <div className="flex flex-row space-x-1 md:space-x-4">
                    {renderHeaderRight && renderHeaderRight()}

                      <button className=" btn-icon shadow-md md:bg-white">
                        <HamburgerIcon
                          className="h-12 fill-current text-gray"
                          onClick={this.toggleMenu}
                        />
                      </button>
                  </div>
                </div>
                {this.state.isHamburgerMenuOpen && (
                  <div className="absolute z-10 w-full sm:w-96 shadow-md px-8 py-4 pt-12 bg-white vh-30 right-0 top-20 mt-auto">
                    <ul className="list-none">
                      <li className="border-none border-gray-lighter py-4">
                        <LanguageSelector className="navbar-menu" />
                      </li>

                      {/* <li className="border-t flex justify-between border-gray-lighter py-4">
                        <Link to="/settings/" className="text-gray">
                          {t("NAVBAR.TOOLTIP.SETTINGS")}
                        </Link>{" "}
                        <Link to="/settings/">
                          <ChevronRightIcon className="h-4 w-4 float-right text-gray fill-current" />
                        </Link>
                      </li> */}

                      <li className="border-t flex justify-between border-gray-lighter py-4">
                        <a
                          className="text-gray"
                          href={t("URLS.ABOUT")}
                          target="_new"
                        >
                          {t("NAVBAR.TOOLTIP.ABOUT")}
                        </a>{" "}
                        <a
                          href={t("URLS.ABOUT")}
                          target="_new"
                        >
                          <ChevronRightIcon className="h-4 w-4 text-gray fill-current" />
                        </a>
                      </li>

                      <li className="flex justify-between border-gray-lighter py-4">
                        <a
                          className="text-gray"
                          href={t("URLS.WEBSITE_GUIDE")}
                          target="_new"
                        >
                          {t("NAVBAR.TOOLTIP.WEBSITE_GUIDE")}
                        </a>{" "}
                        <a
                          href={t("URLS.WEBSITE_GUIDE")}
                          target="_new"
                        >
                          <ChevronRightIcon className="h-4 w-4 text-gray fill-current" />
                        </a>
                      </li>

                      <li className="flex justify-between border-gray-lighter py-4">
                        <a
                          className="text-gray"
                          href="https://trustedspotter.eu/reporting-parameters"
                          target="_new"
                        >
                          {t("NAVBAR.TOOLTIP.INFO")}
                        </a>{" "}
                        <a
                          href="https://trustedspotter.eu/reporting-parameters"
                          target="_new"
                        >
                          <ChevronRightIcon className="h-4 w-4 text-gray fill-current" />
                        </a>
                      </li>

                      <li className="flex justify-between border-gray-lighter py-4">
                        <a
                          className="text-gray"
                          href="https://trustedspotter.eu"
                          target="_new"
                        >
                          {t("NAVBAR.TOOLTIP.WEBSITE")}
                        </a>{" "}
                        <a
                          href="https://trustedspotter.eu"
                          target="_new"
                        >
                          <ChevronRightIcon className="h-4 w-4 text-gray fill-current" />
                        </a>
                      </li>

                      <li className="flex justify-between border-gray-lighter py-4">
                        <a
                          className="text-gray"
                          href={t("URLS.CONTACT")}
                          target="_new"
                        >
                          {t("NAVBAR.TOOLTIP.CONTACT")}
                        </a>{" "}
                        <a
                          href={t("URLS.CONTACT")}
                          target="_new"
                        >
                          <ChevronRightIcon className="h-4 w-4 text-gray fill-current" />
                        </a>
                      </li>

                       <li className="border-t flex justify-between  border-gray-lighter py-4 text-gray items-center">
                        {user.username ? (
                          <React.Fragment>
                          <Link className="text-gray flex flex-row space-x-4 items-center" to="/my/">
                            <button className="btn-icon bg-petrol text-white active:bg-petrol-darker">
                              <UserIcon />
                            </button>
                            <div>
                              {user.username}
                            </div>
                          </Link>
                          <Link to="/my/">
                            <ChevronRightIcon className="h-4 w-4 text-gray fill-current" />
                          </Link>
                          </React.Fragment>
                        ) : (
                          <React.Fragment>
                          <Link className="text-gray flex flex-row space-x-4 items-center" to="/login/">
                            <button className="btn-icon bg-petrol text-white active:bg-petrol-darker">
                              <UserIcon />
                            </button>
                            <div>{t("SCREENS.LOGIN.TITLE")}</div>
                          </Link>
                          <Link to="/login/">
                            <ChevronRightIcon className="h-4 w-4 text-gray fill-current" />
                          </Link>
                          </React.Fragment>
                        )}

                      </li>

                      <li className="border-gray-lighter py-4">
                        <SocialShare
                          url={window.location.href}
                          subject="wettermelden.at"
                          text="Check out wettermelden.at - Report weather conditions in real-time!"
                          platforms={['email', 'facebook', 'sms', 'telegram', 'messenger', 'whatsapp']}
                          showLabels={true}
                          containerClassName="social-share-container--list"
                          className="w-full justify-start"
                        />
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            </div>
            </div>
          );
        }}
      </Context.Consumer>
    );
  }
}

export default Navbar;
